// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__2d8eT","load7":"Spinner_load7__3rr76","MiniLoader":"Spinner_MiniLoader__3-Ro2","marginCollapsingBox":"Spinner_marginCollapsingBox__14JLZ"};